// extracted by mini-css-extract-plugin
export default {"companyContainer":"MM-z","companyImage":"NM-z","container":"OM-z","heading":"PM-z","darkText":"QM-z","smallHeading":"RM-z","darkBackground":"SM-z","whiteBackground":"TM-z"};